import { Search } from '@mui/icons-material';

export const SearchIcon = () => {
  return <Search role="img" fontSize="small" style={{ marginRight: '8px' }} />;
};
